import React, { useMemo, useState } from 'react';
import Input from '../../UI/Input';
import Button from '../../UI/Button';
import AISuggestionModal from '../AISuggestionModal';
import * as validators from '../../../utils/validators';

export default function PersonalInfoForm({ data = {}, onChange }) {
	const [errors, setErrors] = useState({});
	const [openAI, setOpenAI] = useState(false);
	const [jobTitle, setJobTitle] = useState('');

	function update(field, value) {
		onChange?.({ ...data, [field]: value });
	}

	function validate() {
		const e = {};
		if (!data.name?.trim()) e.name = 'Name is required';
		if (!validators.validateEmail(data.email || '')) e.email = 'Valid email required';
		if (!data.phone?.trim()) e.phone = 'Phone is required';
		if (data.summary && String(data.summary).length > 600) e.summary = 'Summary too long (max 600 chars)';
		setErrors(e);
		return Object.keys(e).length === 0;
	}

	useMemo(() => {
		// validate on data change (soft)
		validate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
			<Input name="name" label="Full Name" value={data.name || ''} onChange={(e) => update('name', e.target.value)} error={errors.name} required />
			<Input name="email" label="Email" value={data.email || ''} onChange={(e) => update('email', e.target.value)} error={errors.email} required />
			<Input name="phone" label="Phone" value={data.phone || ''} onChange={(e) => update('phone', e.target.value)} error={errors.phone} required />
			<Input name="location" label="Location" value={data.location || ''} onChange={(e) => update('location', e.target.value)} />
			<Input name="linkedin" label="LinkedIn URL" value={data.linkedin || ''} onChange={(e) => update('linkedin', e.target.value)} />
			<Input name="portfolio" label="Portfolio/Website URL" value={data.portfolio || ''} onChange={(e) => update('portfolio', e.target.value)} />
			<div className="md:col-span-2">
				<div className="flex items-center justify-between">
					<label className="block text-sm font-medium text-gray-700 mb-1">Professional Summary</label>
					<div className="text-xs text-gray-500">{(data.summary || '').length}/600</div>
				</div>
				<textarea
					className={`w-full rounded-md border ${errors.summary ? 'border-red-500' : 'border-gray-300'} px-3 py-2`}
					rows="5"
					maxLength={600}
					value={data.summary || ''}
					onChange={(e) => update('summary', e.target.value)}
				/>
				{errors.summary && <p className="mt-1 text-xs text-red-600">{errors.summary}</p>}
				<div className="mt-2 flex items-center gap-2">
					<input
						className="rounded-md border border-gray-300 px-3 py-2 text-sm"
						placeholder="Your desired job title (optional)"
						value={jobTitle}
						onChange={(e) => setJobTitle(e.target.value)}
					/>
					<Button type="button" variant="secondary" onClick={() => setOpenAI(true)}>
						Get AI Suggestions
					</Button>
				</div>
			</div>
			<AISuggestionModal
				isOpen={openAI}
				onClose={() => setOpenAI(false)}
				sectionType="summary"
				promptContext={{ jobTitle, currentDescription: data.summary || '' }}
				onSelect={(text) => update('summary', text)}
			/>
		</div>
	);
}


